import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';

import { DriverDocuments } from './_authenticated._main.driver/DriverDocuments';
import { DriverForm } from './_authenticated._main.driver/DriverForm';
import { DriverMultiTables } from './_authenticated._main.driver/DriverMultiTables';
import { SecondaryButton } from '../components/button/SecondaryButton';
import { Spinner } from '../components/Spinner';
import { constants } from '../constants';
import { useFetchDriver } from '../hooks/useFetchDriver';
import { t } from '../services/translation/translation';
import { getFullName } from '../utils/common';

export const DriverRoute = () => {
  const { driverKey } = useParams();
  const navigate = useNavigate();

  invariant(driverKey);

  const { data: driver, isLoading } = useFetchDriver(driverKey);

  if (isLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!driver) {
    return (
      <div>
        <h3 className="text-3xl font-bold dark:text-white mb-6">{t('common.error')}</h3>
        <div className="inline-block space-y-2">
          <div className="h-96 w-96 bg-confused-light dark:bg-confused-dark bg-no-repeat bg-contain bg-center" />
          <p className="text-center">{t('driver-route.not-found')}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Helmet>
        <title>{getFullName(driver.firstName, driver.lastName)} - Allocab</title>
      </Helmet>
      <h3 className="text-3xl font-bold dark:text-white mb-6">{getFullName(driver.firstName, driver.lastName)}</h3>
      <div className="mb-4 flex items-start flex-wrap gap-4">
        <DriverForm driver={driver} />
        <div>
          <DriverDocuments driverKey={driver.id} />
          {/* TODO: Remove isProd condition when ready for production */}
          {driver.canBeDedicated && !constants.isProd ? (
            <div
              className={
                'flex-col min-w-full sm:min-w-0 gap-2 p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 mt-3 space-y-1'
              }
            >
              <h6 className="text-lg mb-2 font-bold dark:text-white">{t('common.package-preference')}</h6>
              <SecondaryButton onClick={() => navigate('preferences')}>
                {t('driver-route.trip-package-button')}
              </SecondaryButton>
            </div>
          ) : null}
        </div>
      </div>
      <div>
        <DriverMultiTables driverKey={driverKey} />
      </div>
    </div>
  );
};
